<template>
  <div>
    <!-- 塾検索フォーム -->
    <v-form
      ref="search-form"
      :value="searchFormValid"
      lazy-validation
    >
      <table class="ml-3 mt-8">
        <thead>
          <th class="search-th">
            お客様No.
            <font class="float-right question" style="cursor:pointer" @click="showPDF">？</font>
          </th>
          <th class="search-th">塾代表電話番号</th>
        </thead>
        <tbody>
          <td>
            <v-text-field
              class="text-field ma-0"
              :value="searchForm.clientCode"
              @change="setSearchFormPayload({ clientCode: $event })"
              outlined
              dense
              required
              hide-details
              :rules="rules.clientCode"
              color="secondary"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              class="text-field ma-0"
              :value="searchForm.tel"
              @change="setSearchFormPayload({ tel: $event })"
              outlined
              dense
              required
              hide-details
              :rules="rules.tel"
              color="secondary"
            ></v-text-field>
          </td>
        </tbody>
      </table>
      <v-btn
        color="secondary"
        class="ml-3 mt-3 mb-8"
        small
        :disabled="!searchForm.clientCode || !searchForm.tel"
        @click.stop="search"
      >
        この条件で検索
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import rules from '../../rules'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
  },

  data() {
    return {
      rules: rules,
    }
  },

  props: {},

  computed: {
    ...mapState('enrollment',[
      'searchForm',
      'searchFormValid',
    ]),
  },

  methods: {
    ...mapMutations('enrollment', [
      'setCustomerPayload',
      'setRegisteredClassrooms',
      'setSearchFormPayload',
      'setSearchFormValid',
    ]),
    async search() {
      const searchFormValid = this.$refs["search-form"].validate()
      this.setSearchFormValid({ valid: searchFormValid })
      if (!searchFormValid) {
        this.$toasted.global.error({ message: 'お客様No.もしくは塾代表電話番号の入力に不備があります。' })
        return
      }
      // 既存情報取得
      const url = `/api/v1/enrollment/customers/search/?code=${this.searchForm.clientCode}&tel=${this.searchForm.tel}`
      const res = await this.$axios.get(url)

      this.setCustomerPayload({
        id: res.data.id,
        clientCode: res.data.code,
        name: res.data.name,
        address: res.data.address,
        tel: res.data.tel,
        mail: res.data.email,
        logoFilename: res.data.logoFilename,
        enChargePerson: res.data.representative,
        invoiceType: res.data.billing,
      })
      this.setRegisteredClassrooms({ branches: res.data.branches })

      // ロゴ画像の設定があった場合、ロゴ画像表示処理
      if(!res.data.logoFilename) return
      const resBlob = await this.$axios(res.data.logoUrl, { responseType: 'blob' })
      const blob = new Blob([resBlob.data], { type: resBlob.data.type })
      const file = new File([blob], res.data.logoFilename, { type: resBlob.data.type })
      this.setCustomerPayload({ logoFile: file })
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        this.setCustomerPayload({ logoImage:  e.target.result })
      }
    },
    showPDF() {
      window.open('https://www.en-plat.jp/%E3%81%8A%E5%AE%A2%E6%A7%98CD%E7%A2%BA%E8%AA%8D%E7%94%A8.pdf')
    }
  },
}
</script>

<style lang="stylus" scoped>

.search-th
  width 100px
  height 20px
  background-color #3b7cab
  text-align center
  color #fff
  font-size 13px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

.form-th
  width 30%
  height 30px
  background-color #3b7cab
  text-align left
  color #fff
  font-size 14px
  vertical-align top
  padding 9px
  border-bottom 1px solid #ddd

.form-td
  width 1500px
  background-color #fff1f8
  border 1px solid white

.question
  font-size 16px
  text-shadow 0px 1px white
  color #ff4a3d !important

</style>
